import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

/**
 * Generated class for the RecursiveGridComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "recursive-grid",
  templateUrl: "recursive-grid.html",
})
export class RecursiveGridComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() rowProps: object;
  @Input() cols: object[] = [];
  @Input() inputs: object[] = [];

  constructor() {
    // console.log('Hello RecursiveGridComponent Component');
  }

  ngOnInit(): void {}
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/recursive-grid/recursive-grid.ts